// ================================================================
// CompanyDashboard — کنترل‌پنل مدیر شرکت (صفحه‌ی فرود بعد از لاگین)
// فقط برای کاربرانِ غیرپلتفرم (isPlatform=false).
// دادهٔ واقعی از core/org.js؛ مدیریتِ عمیق از طریق OrgPanelِ موجود.
// نمایش/پنهان‌سازیِ دکمه‌ها بر اساس can() — امنیتِ واقعی سمت بک‌اند است.
// ================================================================
import './company-dashboard.css';
import { t, getLanguage, setLanguage, getAvailableLanguages } from '../../i18n/index.js';
import { events, EVENTS } from '../../core/events.js';
import { WHATSAPP_ENABLED } from '../../core/features.js';
import { onUiCommand } from '../../core/uiCommands.ts';
import { ghostTap } from '../../core/ghostPointer.js';
import { amount, money, date as fmtDate, dateTime as fmtDateTime } from '../../utils/format.ts';
import { icon, escapeHtml, delegate } from '../../utils/dom.js';
import { initEditPersons, editPersonField, editPersonsHtml, saveEditPersons } from './contact-persons-edit.js';
import { initCust2Swipe } from './cust2-swipe.js';
import { getUser, getPermissions, isModuleEnabled, logout } from '../../core/auth.js';
import { listMembers, listRoles, listInvitations, listWorkTimeModels, listWageGroups, listBausteine, getHolidays, getUnits, getSurcharges, getNumberRanges, getPaymentTerms, getDocumentTexts, getFileNaming, getEmailSettings, getWhatsappTextSettings, getLetterhead, getAttachments, getDunning, getPaymentCode, getPartialInvoiceSettings, getLabourCostDisplay } from '../../core/org.js';
import { openOrgPanel } from '../org/OrgPanel.js';
import { renderEmployeesSection, renderInviteModal, renderEditModal, inviteHeadButton, handleEmployeesAction } from './settingsEmployees.js';
import { renderWorkTimeSection, workTimeHeadButton, renderWorkTimeModal, handleWorkTimeAction, recalcWorkTimeTotals } from './settingsWorkTime.js';
import { renderWageGroupsSection, wageGroupsHeadButton, renderWageGroupModal, handleWageGroupAction, recalcWageGroup } from './settingsWageGroups.js';
import { renderBausteineSection, bausteineHeadButton, renderBausteinModal, handleBausteinAction } from './settingsBausteine.js';
import { renderHolidaysSection, renderHolidayModal, handleHolidayAction, handleHolidayCantonChange } from './settingsHolidays.js';
import { renderRolesSection, rolesHeadButton, renderRoleModal, handleRoleAction } from './settingsRoles.js';
import { renderConnectionsSection, renderConnectionsModal, handleConnectionsAction, loadConnections } from './settingsConnections.js';
import { renderUnitsSection, renderUnitsListModal, renderUnitDefaultsModal, handleUnitAction } from './settingsUnits.js';
import { renderSurchargesSection, surchargesHeadButton, handleSurchargeAction } from './settingsSurcharges.js';
import { renderNumberRangesSection, numberRangesHeadButton, renderPaymentTermsSection, paymentTermsHeadButton, handleAccountingAction, renderPaymentCodeSection, paymentCodeHeadButton, renderPartialInvoiceSettingsSection, partialInvoiceSettingsHeadButton, renderLabourCostDisplaySection, labourCostDisplayHeadButton } from './settingsAccounting.js';
import { renderDocumentTextsSection, documentTextsHeadButton, handleDocumentTextsAction, syncFromDom as syncDocumentTexts } from './settingsDocumentTexts.js';
import { renderFileNamingSection, renderFileNamingModal, handleFileNamingAction, handleFileNamingChange } from './settingsFileNaming.js';
import { renderEmailSendSection, emailSendHeadButton, handleEmailSendAction } from './settingsEmailSend.js';
import { renderWhatsappTextSection, whatsappTextHeadButton, handleWhatsappTextAction } from './settingsWhatsappText.js';
import { renderAccountSection, accountHeadButton, handleAccountAction, handleMfaAction } from './settingsAccount.js';
import { loadDevices, handleDevicesAction } from './settingsDevices.js';
import { renderLetterheadSection, renderLetterheadModal, handleLetterheadAction, loadLetterheadPreview, handleLetterheadFontChange, loadLetterheadBackgrounds, syncFromDom as syncLetterhead } from './settingsLetterhead.js';
import { renderAttachmentsSection, handleAttachmentAction } from './settingsAttachments.js';
import { renderDunningSection, renderDunningModal, renderDunningSendModal, handleDunningAction, dunningHeadButton, syncFromDom as syncDunning } from './settingsDunning.js';
import { fetchDunningCandidates } from '../../core/dunning.js';
// Dokument-APIs leben jetzt in documentsView.js / sendModal.js — hier nur noch Firmenprofil
import { getCompanyProfile, saveCompanyProfile, uploadCompanyLogo, fetchCompanyLogoBlob } from '../../core/documents.js';
import { initCustomers, handleCustomerAction, handleCustomerSearch, handleNewCustomerField, handleNewCustomerPersonField, newCustomerFormHtml, isNewFormOpen, trashViewHtml, isTrashOpen } from './CustomersView.js';
import { sendWaDraft, sendWaDraftVoice, dismissWaDraft } from './wa-draft-ui.js';
import { initDashboardWidgets, emailKpis, whatsappKpis, todayTimeline } from './dashboardWidgets.js';
import { initEmailView, emailPage, loadEmails, connectGmail, toggleFilter, removeEmail, openEmailModal, closeEmailModal, analyzeOne, analyzeAll, reanalyzeAll, toggleLayout, selectEmail, suggestEmailNow } from './emailView.js';
import { initDocumentsView, loadDocuments, loadCustomers2, askConfirm, closeConfirm, confirmYes, renderConfirmModal } from './documentsView.js';
// Dokumente-Ansicht ist eine React-Insel (react/components/documents/) — die
// Shell steuert nur noch Filter-Reset + Papierkorb-Flag über dieses Singleton
// (gleiche Lebensdauer wie früher s.docFilter/s.trashMode).
import { docsUi } from '../../react/components/documents/docsUiState.ts';
import { initWhatsappView, whatsappPage, updateSendButton, sendWaMessage, sendWaVoiceMessage, renderWaChatList, hydrateWaMedia, openWaChat, waDraftCtx, switchWaInstance, addWaInstance, removeWaInstance, renameWaInstance, loadWaInstances, connectWa, disconnectWa, stopWaChatsPoll, stopWaPoll } from './whatsappView.js';
import { initSendModal, openSendModal, closeSendModal, setSendTab, setSendWaMode, toggleCcDropdown, selectCc, sendModalInput, submitSendModal, renderSendModal, applySendSheetCommand } from './sendModal.js';
import { mountAssistantBar } from '../assistant-bar/AssistantBar.js';
import { archiveProject as apiArchiveProject, deleteProject as apiDeleteProject, updateProject as apiUpdateProject, createProject as apiCreateProject, listProjects as apiListProjects } from '../../core/projects.js';
import { listMembers as apiListMembers } from '../../core/org.js';
import {
  ORG_THEMES, ORG_THEME_DOTS, getCurrentOrgTheme, loadOrgTheme,
  saveOrgTheme as saveOrgThemeApi,
} from '../../core/orgTheme.js';
import { listCustomers as apiListCustomers, createCustomer as apiCreateCustomer } from '../../core/customers.js';

let root = null;
let perms = new Set();

const s = { loading: true, error: '', members: [], roles: [], invitations: [], accordionOpen: false, firstDraw: true, view: 'dashboard', emailLoading: false, emailError: '', emailSyncWarning: '', emails: [], allEmails: [], emailCategory: 'all', emailAccount: '', emailConnectionId: null, emailLoaded: false, connecting: false, analyzingIds: new Set(), analyzingAll: false, openEmail: null, openEmailLoading: false, emailLayout: 'list', selectedEmailId: null, selectedEmail: null, selectedLoading: false, suggestions: [], suggestLoading: false, suggestForId: null, waLoading: false, waConnecting: false, waConnected: false, waStatus: 'pending', waQr: '', waPairing: '', waError: '', waPhone: null, waChats: [], waChatsLoading: false, waActiveChat: null, waMessages: [], waMessagesLoading: false, waSearch: '', waSending: false, waDraft: '', waSettingsOpen: false, waDraftData: null, waDraftText: '', waDraftLoading: false, waDraftSending: false, waDraftErr: '', waMediaCache: {}, waMediaLoading: {}, waLightbox: null, waInstances: [], waActiveInstance: null, waSwitcherOpen: false, docs: [], docsLoading: false, docsError: '', docsLoaded: false, confirmModal: null, fpForm: null, fpLoading: false, fpSaving: false, fpError: '', fpSaved: false, logoUploading: false, logoError: '', logoPreview: '', sendModal: null, sendBusy: false, sendError: '', sendOk: false, sendTab: 'email', sendWaInstance: null, sendWaMode: 'chat', sendWaJid: '', sendWaNumber: '', sendWaCaption: '', sendWaChats: [], sendWaChatsLoading: false, sendWaCountry: '41', sendCcOpen: false, cust2List: [], cust2Loading: false, cust2Loaded: false, cust2Error: '', cust2SelectedId: null, cust2PanelOpen: false, workTimeModels: [], wtmLoading: false, wtmEdit: null, wageGroups: [], wgLoading: false, wgEdit: null, bausteine: [], bsLoading: false, bsEdit: null, holidayData: null, hdLoading: false, hdEdit: null, roleEdit: null, unitData: null, unLoading: false, unListEdit: null, unDefEdit: null, surcharges: null, scLoading: false, scSaving: false, numberRanges: null, paymentTerms: null, acLoading: false, nrSaving: false, ptSaving: false, documentTexts: null, dtSaving: false, fileNaming: null, fnSaving: false, fnEdit: null, emailDefaults: null, esSaving: false, whatsappText: null, wtSaving: false, lhData: null, lhEdit: null, lhSaving: false, lhTab: 'dokumente', lhPreview: '', lhPreviewLoading: false, lhBgPreview: {}, lhBgUploading: false, lhBgError: '', aaData: null, aaOpen: null, aaUploading: null, aaError: '', dunning: null, mhEdit: null, mhSaving: false, dunningCandidates: null, mhSend: null, mhWaInstances: null, paymentCode: null, bcSaving: false, partialInvoiceSettings: null, piSaving: false, labourCostDisplay: null, lcSaving: false, vbConnections: [], vbInstances: [], vbLoading: false, vbError: '', vbBusy: false, vbQrModal: null };
// long-press state for touch devices (module-level so it survives draw())
let cust2TouchTimer = null;
let cust2TouchSX = 0, cust2TouchSY = 0;
let cust2LongPressFired = false;
function can(p) { return perms.has(p); }

// Datei-Split (Runde 1): herausgelöste Module bekommen den geteilten State +
// draw/can einmal injiziert (function declarations sind gehoisted — safe).
// Nächste Runden: E-Mail-View, WhatsApp-View, Dashboard-Widgets.
initDashboardWidgets({ s, can, grad, initials });
initEmailView({ s, draw, can, grad, initials });
initDocumentsView({ s, draw });
initSendModal({ s, draw, loadWaInstances });
initWhatsappView({ s, draw, whatsappKpis, getRoot: () => root });

// ── Modul-Gate (Plan/Entitlements) — sichtbare Navigation je Org-Plan ──
// امنیت واقعی سمت بک‌اند است (effectivePermissions)؛ اینجا فقط نمایش.
function viewAllowed(v) {
  switch (v) {
    case 'projekte': return isModuleEnabled('projects');
    case 'plans': return can('time:read');
    // Planungstafel = Projekte auf der Zeitachse; dasselbe Modul wie die Projektliste.
    case 'planning': return isModuleEnabled('projects');
    case 'termine': return can('appointments:read');
    case 'leads': return can('leads:read');
    case 'gutscheine': return can('vouchers:read');
    case 'email': return can('email:read');
    // WhatsApp pausiert (core/features.js): der ganze Bereich verschwindet aus
    // Navigation und Routing. Der Code bleibt — nur der Weg dorthin fehlt.
    case 'whatsapp': return WHATSAPP_ENABLED && can('whatsapp:send');
    case 'documents': return can('documents:read');
    case 'customers2': return can('customers:read');
    default: return true; // dashboard/einstellungen/firmenprofil — خودشان per-permission گیت می‌شوند
  }
}

let langListenerBound = false;

// Sprachumschalter im Workspace-Menü. Liest die Sprachen aus der i18n-Registry,
// damit eine neue Sprache nur in i18n/index.js eingetragen werden muss und hier
// von selbst auftaucht — nichts ist auf DE/EN hartkodiert.
function langSwitcher() {
  const langs = getAvailableLanguages();
  if (langs.length < 2) return ''; // eine Sprache = kein Umschalter
  const cur = getLanguage();
  // Mit 17 Sprachen ist eine Pill-Reihe unbrauchbar → kompaktes Select
  const opts = langs
    .map((l) => `<option value="${escapeHtml(l.code)}" ${l.code === cur ? 'selected' : ''}>${escapeHtml(l.name)}</option>`)
    .join('');
  return `
    <div class="cd-ws-menu-sep"></div>
    <div class="cd-ws-lang">
      <span class="cd-ws-menu-ic">${icon('language', 18)}</span>
      <span class="cd-ws-lang-label">${escapeHtml(t('dashboard.language'))}</span>
      <select class="cd-ws-lang-select">${opts}</select>
    </div>`;
}

const GRADS = [
  ['#10b981', '#059669'], ['#3b82f6', '#6366f1'], ['#8b5cf6', '#6366f1'],
  ['#f59e0b', '#ec4899'], ['#06b6d4', '#3b82f6'], ['#f43f5e', '#f97316'],
];
function grad(key) {
  let h = 0; const str = String(key || '');
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  const g = GRADS[h % GRADS.length];
  return `linear-gradient(135deg, ${g[0]}, ${g[1]})`;
}
function initials(name, email) {
  const base = String(name || email || '?').trim();
  const parts = base.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return base.slice(0, 2).toUpperCase();
}

// ─── org-theme-helpers: Firmenfarbe (org-scoped Branding) ───
// Liste, Farbpunkte und das Speichern liegen in core/orgTheme.js — dieselbe
// Quelle wie Handy-App und Onboarding. Hier bleibt nur, was DIESE Oberfläche
// zusätzlich braucht: das `data-theme` am .cd-root (die --cd-*-Varianten hängen
// daran), plus die Auswahl-Kacheln.

// Farbschema-Auswahl (Firmenprofil + Einstellungen › Design) — eine Stelle statt
// zweier fest hartkodierter Kopien, damit Namen/Reihenfolge nicht auseinanderlaufen.
function themeSwatchesHtml() {
  return ORG_THEMES.map((th) => {
    const label = t('dashboard.theme.' + th);
    return `<button type="button" class="cd-theme-swatch" data-action="set-theme" data-theme="${th}" title="${escapeHtml(label)}"><span class="cd-theme-dot" style="background:${ORG_THEME_DOTS[th]}"></span><span class="cd-theme-name">${escapeHtml(label)}</span></button>`;
  }).join('');
}

function applyThemeToDom(el, theme) {
  if (!el) return;
  if (theme && theme !== 'violet' && ORG_THEMES.includes(theme)) {
    el.setAttribute('data-theme', theme);
  } else {
    el.removeAttribute('data-theme'); // violet = default (kein Attribut noetig)
  }
}

async function applyOrgTheme(el) {
  applyThemeToDom(el, getCurrentOrgTheme()); // gemerkte Farbe sofort, ohne Netz
  applyThemeToDom(el, await loadOrgTheme());
}

export async function setOrgTheme(theme) {
  if (!ORG_THEMES.includes(theme)) return;
  const el = document.getElementById('cd-root');
  applyThemeToDom(el, theme); // sofort optimistisch anwenden
  try {
    await saveOrgThemeApi(theme);
  } catch {
    // Nicht gespeichert = nicht als gewählt zeigen: zurück auf den Stand der DB.
    applyThemeToDom(el, getCurrentOrgTheme());
    draw();
  }
}

export function showCompanyDashboard(appRoot) {
  root = appRoot;
  perms = getPermissions();
  document.title = t('dashboard.title');
  root.innerHTML = '<div class="cd-root" id="cd-root"></div>';
  const container = root.querySelector('#cd-root');
  applyOrgTheme(container); // org-theme-apply: Theme aus DB laden und setzen
  mountAssistantBar(root);
  delegate(container, '[data-action]', 'click', onAction);
  // Sprachwechsel → neu zeichnen. Ohne das blieben alle t()-Werte auf dem Stand
  // des ersten draw() stehen und der Umschalter wäre wirkungslos.
  // Nur einmal registrieren: showCompanyDashboard() läuft bei jedem Login erneut.
  if (!langListenerBound) {
    langListenerBound = true;
    events.on(EVENTS.LANGUAGE_CHANGED, () => {
      document.title = t('dashboard.title');
      draw();
    });
    // Voice-Navigation (open_view): gleiche Route wie ein Klick in der Topbar.
    // Mapping Tool-Vokabular → interne View-Keys; setView prüft viewAllowed
    // selbst nochmal (Modul-Gate), wir melden «nicht verfügbar» ehrlich zurück.
    const VOICE_VIEWS = {
      dashboard: 'dashboard', leads: 'leads', customers: 'customers2',
      documents: 'documents', email: 'email', whatsapp: 'whatsapp',
      projects: 'projekte', times: 'plans', calendar: 'termine',
      planning: 'planning',
      vouchers: 'gutscheine',
      // «Einstellungen öffnen» — fehlte hier, obwohl das Tool die Ansicht
      // kennt; der Assistent bekam «kann ich nicht».
      settings: 'einstellungen',
    };
    onUiCommand('OPEN_VIEW', (cmd) => {
      const v = VOICE_VIEWS[cmd.view];
      if (!v || !viewAllowed(v)) return false;
      // Termin-Tools schicken den Tag mit (OPEN_VIEW calendar + date): der
      // Kalender öffnet auf diesem Tag, damit der Nutzer die Änderung sieht.
      if (v === 'termine' && cmd.date && /^\d{4}-\d{2}-\d{2}$/.test(cmd.date)) {
        s.termineFocus = { seq: (s.termineFocus ? s.termineFocus.seq : 0) + 1, date: cmd.date };
      }
      // Dieselbe Idee fuer die Planungstafel: hat der Assistent ein Projekt
      // eingeplant, springt die Tafel auf dessen Woche.
      if (v === 'planning' && cmd.date && /^\d{4}-\d{2}-\d{2}$/.test(cmd.date)) {
        s.planningFocus = cmd.date;
      }
      // Sichtbar auf den Menüpunkt tippen, bevor die Ansicht wechselt — der
      // Nutzer soll sehen, WOHIN der Assistent fasst (core/ghostPointer.js).
      // Findet der Zeiger das Ziel nicht, wechselt die Ansicht trotzdem.
      const ziel = document.querySelector(`[data-voice-target="${cmd.view}"]`);
      if (ziel) ghostTap(ziel).then(() => setView(v));
      else setView(v);
      return true;
    });
    // Voice: open_lead → Leads-View + Karte ins Bild scrollen/aufblitzen
    // (Desktop hat kein Lead-Detail; Flag wird beim LeadsView-Mount konsumiert).
    onUiCommand('OPEN_LEAD', (cmd) => {
      if (!viewAllowed('leads')) return false;
      s.leadsHighlightId = cmd.leadId;
      setView('leads');
      return true;
    });
    // Voice: open_email → E-Mail-View + DIESE Mail öffnen. Split-Layout wählt
    // per selectEmail (rechte Spalte), Listen-Layout per Modal — dieselben
    // zwei Wege, die ein Klick auf die Zeile nimmt.
    onUiCommand('OPEN_EMAIL', (cmd) => {
      if (!viewAllowed('email')) return false;
      setView('email');
      if (s.emailLayout === 'split') selectEmail(cmd.emailId);
      else openEmailModal(cmd.emailId);
      return true;
    });
    // Voice: open_offer_for_lead → OfferForm im Edit-Modus, gleicher Pfad wie
    // der «Offerte öffnen»-Klick in der Leads-Liste (onOpenDocument).
    onUiCommand('OPEN_OFFER', (cmd) => {
      if (!viewAllowed('documents')) return false;
      setView('documents');
      // Picker schliessen: mainInner rendert ihn VOR dem Formular — stand er
      // noch offen (Voice-Flow «neue Offerte»), blieb die Kundenauswahl auf dem
      // Schirm und die eben angelegte Offerte war unsichtbar.
      s.reactCustomerPicker = null;
      s.reactOfferForm = { docType: cmd.docType || 'OFFER', customer: null, editId: cmd.documentId };
      draw();
      return true;
    });
    // Voice «erstell mir eine Offerte» = wie der «+»-Klick (new-offer):
    // Dokumente-Ansicht + Kunden-Picker. Diktierte Kundendaten (prefill) klappen
    // dort das «Neuer Kunde»-Formular auf — dasselbe Bild wie im Handy-Sheet.
    onUiCommand('OPEN_NEW_OFFER', (cmd) => {
      if (!viewAllowed('documents')) return false;
      setView('documents');
      s.reactOfferForm = null;
      // positions: beim Diktat genannte Arbeiten — der CustomerPicker trägt sie
      // in den Entwurf ein, sobald der Kunde angelegt ist (wie am Handy).
      s.reactCustomerPicker = { docType: 'OFFER', prefill: cmd.prefill || null, positions: cmd.positions || null };
      draw();
      return true;
    });
    // Voice «schick es» → derselbe Senden-Dialog, den der Knopf öffnet.
    // Ohne diesen Handler blieb der Desktop-Bildschirm stehen, während der
    // Assistent «der Dialog ist offen» meldete.
    onUiCommand('SEND_SHEET', (cmd) => {
      if (!viewAllowed('documents')) return false;
      const id = cmd.documentId || (s.sendModal && s.sendModal.id);
      if (!id) return false;
      setView('documents');
      void applySendSheetCommand({ ...cmd, documentId: id });
      return true;
    });
  }
  // vaghti moshtari-e jadid sakhte shod (dasti/sooti/assistant) → list-e Kunden 2 ra refresh kon
  window.addEventListener('cust2-customer-created', (ev) => {
    s.cust2Loaded = false;
    loadCustomers2();
  });
  initCustomers(draw);
  initCust2Swipe(container);
  container.addEventListener('input', (e) => {
    if (e.target && e.target.dataset && e.target.dataset.editPersonIdx !== undefined) {
      editPersonField(parseInt(e.target.dataset.editPersonIdx, 10), e.target.dataset.editPersonField, e.target.value);
    } else if (e.target && e.target.dataset && e.target.dataset.personIdx !== undefined) {
      handleNewCustomerPersonField(parseInt(e.target.dataset.personIdx, 10), e.target.dataset.personField, e.target.value);
    } else if (e.target && e.target.dataset && e.target.dataset.custField !== undefined) {
      handleNewCustomerField(e.target.dataset.custField, e.target.value);
    } else if (e.target && e.target.dataset && e.target.dataset.custSearch !== undefined) {
      handleCustomerSearch(e.target.value);
    } else if (e.target && e.target.id === 'cd-wa-search') {
      s.waSearch = e.target.value;
      renderWaChatList();
    } else if (e.target && e.target.id === 'cd-wa-input') {
      s.waDraft = e.target.value;
      updateSendButton();
    } else if (e.target && e.target.id === 'cd-wa-draft-text') {
      s.waDraftText = e.target.value;
    } else if (e.target && e.target.dataset && e.target.dataset.fpField) {
      fpFieldInput(e.target.dataset.fpField, e.target.value);
    } else if (e.target && e.target.dataset && e.target.dataset.sendField) {
      sendModalInput(e.target.dataset.sendField, e.target.value);
    } else if (e.target && e.target.dataset && e.target.dataset.sendWaField) {
      s[e.target.dataset.sendWaField] = e.target.value;
    } else if (e.target && e.target.dataset && e.target.dataset.wgRecalc !== undefined) {
      // Lohngruppen-Kalkulation: EK/Verrechnungssatz live neu berechnen (ohne draw)
      recalcWageGroup();
    }
  });
  container.addEventListener('change', (e) => {
    if (e.target && e.target.id === 'cd-logo-file') {
      const file = e.target.files && e.target.files[0];
      if (file) handleLogoFile(file);
    } else if (e.target && e.target.dataset && e.target.dataset.wtmRecalc !== undefined) {
      // Arbeitszeitmodell-Grid: Gesamtzeiten live neu berechnen (ohne draw, damit Eingaben bleiben)
      recalcWorkTimeTotals();
    } else if (e.target && e.target.id === 'hd-canton') {
      // Feiertage: Kanton gewechselt → Feiertage neu generieren
      handleHolidayCantonChange(e.target.value, { s, draw });
    } else if (e.target && e.target.id === 'fn-add-select') {
      // Dateinamen: Element hinzufügen (Dropdown)
      const v = e.target.value; e.target.value = '';
      handleFileNamingChange('add', v, { s, draw });
    } else if (e.target && e.target.id === 'fn-sep-select') {
      // Dateinamen: Trennzeichen gewählt
      handleFileNamingChange('sep', e.target.value, { s, draw });
    } else if (e.target && e.target.id === 'lh-font') {
      // Briefpapier: Schriftart gewechselt → sofort speichern (kein Modal)
      handleLetterheadFontChange({ s, draw, can, reload: () => load(true) });
    } else if (e.target && e.target.classList && e.target.classList.contains('cd-ws-lang-select')) {
      // Sprachwechsel im Workspace-Menü (Select statt Pills — 17 Sprachen).
      // setLanguage() emittiert LANGUAGE_CHANGED → Listener zeichnet neu.
      setLanguage(e.target.value);
    }
  });
  container.addEventListener('keydown', (e) => {
    if (e.target && e.target.id === 'cd-wa-input' && e.key === 'Enter') {
      e.preventDefault();
      sendWaMessage();
    } else if (e.target && e.target.id === 'un-add-input' && e.key === 'Enter') {
      e.preventDefault();
      handleUnitAction('un-add', e.target, { s, draw, can, reload: () => load(true) });
    }
  });
  // wa-settings-outside-close: بستن منوی ستینگ با کلیک بیرون از آن
  container.addEventListener('click', (e) => {
    if (!s.waSettingsOpen) return;
    if (e.target && e.target.closest && e.target.closest('.cd-wa-foot')) return;
    s.waSettingsOpen = false;
    draw();
  });
  // wa-switcher-outside-close: بستن منوی شماره‌ها با کلیک بیرون از آن
  container.addEventListener('click', (e) => {
    if (!s.waSwitcherOpen) return;
    if (e.target && e.target.closest && e.target.closest('.cd-wa-switcher')) return;
    s.waSwitcherOpen = false;
    draw();
  });
  // ws-menu-outside-close: بستن منوی شرکت با کلیک بیرون از آن
  container.addEventListener('click', (e) => {
    if (!s.wsMenuOpen) return;
    if (e.target && e.target.closest && e.target.closest('.cd-ws')) return;
    s.wsMenuOpen = false;
    draw();
  });
  load();
}

async function load(silent = false) {
  if (!silent) { s.loading = true; s.error = ''; draw(); }
  try {
    const [m, r, inv, wtm, wg, bs, hd, un, sc, nr, pt, dt, fn, es, wt, lh, aa, dn, dc, bc, pi, lc] = await Promise.all([
      can('members:read') ? listMembers() : Promise.resolve({ members: [] }),
      can('roles:read') ? listRoles() : Promise.resolve({ roles: [] }),
      can('members:read') ? listInvitations() : Promise.resolve({ invitations: [] }),
      can('worktime:read') ? listWorkTimeModels() : Promise.resolve({ models: [] }),
      can('wages:read') ? listWageGroups() : Promise.resolve({ groups: [] }),
      can('bausteine:read') ? listBausteine() : Promise.resolve({ bausteine: [] }),
      can('holidays:read') ? getHolidays() : Promise.resolve(null),
      can('units:read') ? getUnits() : Promise.resolve(null),
      can('surcharges:read') ? getSurcharges() : Promise.resolve(null),
      can('accounting:read') ? getNumberRanges() : Promise.resolve(null),
      can('accounting:read') ? getPaymentTerms() : Promise.resolve(null),
      can('layout:read') ? getDocumentTexts() : Promise.resolve(null),
      can('layout:read') ? getFileNaming() : Promise.resolve(null),
      can('layout:read') ? getEmailSettings() : Promise.resolve(null),
      can('layout:read') ? getWhatsappTextSettings() : Promise.resolve(null),
      can('layout:read') ? getLetterhead() : Promise.resolve(null),
      can('layout:read') ? getAttachments() : Promise.resolve(null),
      can('accounting:read') ? getDunning() : Promise.resolve(null),
      can('accounting:read') ? fetchDunningCandidates() : Promise.resolve(null),
      can('accounting:read') ? getPaymentCode() : Promise.resolve(null),
      can('accounting:read') ? getPartialInvoiceSettings() : Promise.resolve(null),
      can('accounting:read') ? getLabourCostDisplay() : Promise.resolve(null),
    ]);
    s.members = m.members || [];
    s.roles = r.roles || [];
    s.invitations = inv.invitations || [];
    s.workTimeModels = wtm.models || [];
    s.wageGroups = wg.groups || [];
    s.bausteine = bs.bausteine || [];
    s.holidayData = hd;
    s.unitData = un;
    s.surcharges = sc ? sc.surcharges : null;
    s.numberRanges = nr ? nr.numberRanges : null;
    s.paymentTerms = pt ? pt.paymentTerms : null;
    s.documentTexts = dt ? dt.documentTexts : null;
    s.fileNaming = fn;
    s.emailDefaults = es ? es.emailDefaults : null;
    s.whatsappText = wt;
    s.lhData = lh;
    s.aaData = aa;
    s.dunning = dn ? dn.dunning : null;
    s.dunningCandidates = dc ? dc.candidates : null;
    s.paymentCode = bc ? bc.paymentCode : null;
    s.partialInvoiceSettings = pi ? pi.partialInvoiceSettings : null;
    s.labourCostDisplay = lc ? lc.labourCostDisplay : null;
    s.error = '';
  } catch (e) {
    s.error = e.message || t('dashboard.error');
  } finally {
    s.loading = false; draw();
  }
}

// observer baraye tashkhis-e chasbidan-e search (is-stuck)
var cust2StickyObserver = null;

// draw() ke scrollTop-e list-e Kunden ra hefz mikonad (jelo-ye paridan be bala ra migirad)

function onAction(e, el) {
  const a = el.dataset.action;
  // Einstellungen → Mitarbeiter (eigenes Modul): emp-* Aktionen dorthin routen
  if (a && a.indexOf('emp-') === 0) {
    if (handleEmployeesAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Arbeitszeiten (eigenes Modul): wtm-* Aktionen dorthin routen
  if (a && a.indexOf('wtm-') === 0) {
    if (handleWorkTimeAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Lohngruppen (eigenes Modul): wg-* Aktionen dorthin routen
  if (a && a.indexOf('wg-') === 0) {
    if (handleWageGroupAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Bausteine (eigenes Modul): bs-* Aktionen dorthin routen
  if (a && a.indexOf('bs-') === 0) {
    if (handleBausteinAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Feiertage (eigenes Modul): hd-* Aktionen dorthin routen
  if (a && a.indexOf('hd-') === 0) {
    if (handleHolidayAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Rollen (eigenes Modul): rl-* Aktionen dorthin routen
  if (a && a.indexOf('rl-') === 0) {
    if (handleRoleAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Verbindungen (eigenes Modul): vb-* Aktionen dorthin routen
  if (a && a.indexOf('vb-') === 0) {
    if (handleConnectionsAction(a, el, { s, draw, can, askConfirm })) return;
  }
  // Einstellungen → Einheiten (eigenes Modul): un-* Aktionen dorthin routen
  if (a && a.indexOf('un-') === 0) {
    if (handleUnitAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Zuschläge (eigenes Modul): sc-* Aktionen dorthin routen
  if (a && a.indexOf('sc-') === 0) {
    if (handleSurchargeAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Buchhaltung (eigenes Modul): nr-*/pt-* Aktionen dorthin routen
  if (a && (a.indexOf('nr-') === 0 || a.indexOf('pt-') === 0 || a.indexOf('bc-') === 0)) {
    if (handleAccountingAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Layout & Textvorlagen (eigenes Modul): dt-* Aktionen dorthin routen
  if (a && a.indexOf('dt-') === 0) {
    if (handleDocumentTextsAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Dateinamen (eigenes Modul): fn-* Aktionen dorthin routen
  if (a && a.indexOf('fn-') === 0) {
    if (handleFileNamingAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Briefpapier (eigenes Modul): lh-* Aktionen dorthin routen
  if (a && a.indexOf('lh-') === 0) {
    if (handleLetterheadAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Mahnungen (eigenes Modul): mh-* Aktionen dorthin routen
  if (a && a.indexOf('mh-') === 0) {
    if (handleDunningAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Automatische Anhänge (eigenes Modul): aa-* Aktionen dorthin routen
  if (a && a.indexOf('aa-') === 0) {
    if (handleAttachmentAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → E-Mail Versand (eigenes Modul): es-* Aktionen dorthin routen
  if (a && a.indexOf('es-') === 0) {
    if (handleEmailSendAction(a, el, { s, draw, can, reload: () => load(true) })) return;
    if (handleWhatsappTextAction(a, el, { s, draw, can, reload: () => load(true) })) return;
  }
  // Einstellungen → Mein Konto (eigenes Modul): ac-* Aktionen dorthin routen
  if (a && a.indexOf('ac-') === 0) {
    if (handleAccountAction(a, el, { s, draw })) return;
    if (handleMfaAction(a, el, { s, draw })) return;
  }
  // Einstellungen → Mein Konto → Aktive Geräte (settingsDevices.js)
  if (a && a.indexOf('dv-') === 0) {
    if (handleDevicesAction(a, el, { s, draw })) return;
  }
  // overlay-haye close: faghat agar click rooye KHOD-e overlay bud bebanad,
  // na vaghti rooye mohtava (data-stop) click shode. jelo-ye baste shodan ba click rooye field ra migirad.
  if (a === 'cust2-edit-close' || a === 'cust2-ctx-close') {
    // faghat 2 halat bayad bebanad:
    //  1) click daghighan rooye KHOD-e overlay (background) — yani e.target === el
    //  2) click rooye yek dokme-ye baste ke khodash button ast (.cd-cust2-edit-x / -cancel)
    const onBg = e.target === el;
    const onBtn = e.target && e.target.closest && !!e.target.closest('button[data-action="cust2-edit-close"], button[data-action="cust2-ctx-close"]');
    if (!onBg && !onBtn) return;
  }
  // auto-close wa settings menu on any other action
  if (s.waSettingsOpen && a !== 'toggle-wa-settings' && a !== 'disconnect-whatsapp') { s.waSettingsOpen = false; }


  switch (a) {
    case 'go-dashboard': return setView('dashboard');
    case 'go-email': return setView('email');
    case 'go-whatsapp': return setView('whatsapp');
    case 'connect-whatsapp': return connectWa();
    case 'refresh-qr': return connectWa();
    case 'request-pair-code': {
      s.waPairPhone = (document.getElementById('cd-wa-pair-phone') || {}).value || '';
      return connectWa(s.waPairPhone);
    }
    case 'open-lightbox': s.waLightbox = el.dataset.mid || null; draw(); return;
    case 'close-lightbox': s.waLightbox = null; draw(); return;
        case 'toggle-wa-settings': s.waSettingsOpen = !s.waSettingsOpen; draw(); return;
    case 'toggle-switcher': s.waSwitcherOpen = !s.waSwitcherOpen; draw(); return;
    case 'disconnect-whatsapp': return disconnectWa();
    case 'switch-instance': return switchWaInstance(el.dataset.iid);
    case 'add-instance': return addWaInstance();
    case 'remove-instance': return removeWaInstance();
    case 'rename-instance': return renameWaInstance();
    case 'open-wa-chat': return openWaChat(el.dataset.jid);
    case 'send-wa': return sendWaMessage();
    case 'send-wa-voice': return sendWaVoiceMessage();
    case 'wa-draft-send': return sendWaDraft(waDraftCtx());
    case 'wa-draft-send-voice': return sendWaDraftVoice(waDraftCtx());
    case 'wa-draft-dismiss': return dismissWaDraft(waDraftCtx());
    case 'reload-email': return loadEmails();
    case 'toggle-layout': return toggleLayout();
    case 'select-email': return selectEmail(el.dataset.id);
    case 'suggest-email': return suggestEmailNow(el.dataset.id);
    case 'open-email': return openEmailModal(el.dataset.id);
    case 'close-email': return closeEmailModal();
    case 'analyze-one': return analyzeOne(el.dataset.id);
    case 'delete-email': return removeEmail(el.dataset.id);
    case 'analyze-all': return analyzeAll();
    case 'reanalyze-all': return reanalyzeAll();
    case 'filter-cat': return toggleFilter(el.dataset.cat);
    case 'connect-gmail': return connectGmail();
    case 'open-members':  return openOrgPanel('members', () => load(true));
    case 'open-roles':    return openOrgPanel('roles', () => load(true));
    case 'invite':        return openOrgPanel('members', () => load(true));
    case 'refresh':       return load();
case 'toggle-accordion': return toggleAccordion();
    // Filter-Reset + Papierkorb zu, wie früher via s.docFilter/s.trashMode —
    // die React-Insel liest diese Vorgaben beim Mount aus docsUi.
    case 'go-documents':  docsUi.filter = 'today'; docsUi.trashMode = false; return setView('documents');
    case 'go-customers':  return setView('customers2'); // alt-View 'customers' tot → auf customers2 umleiten
    case 'go-customers2': return setView('customers2');
    case 'go-customers2-new': {
      setView('customers2');
      // form-e kontakt-e jadid ra baz kon (ba'd az switch-e view)
      requestAnimationFrame(function () { handleCustomerAction('cust-new', null); });
      return;
    }
    case 'go-projekte': return setView('projekte');
    case 'go-plans': return setView('plans');
    case 'go-planning': return setView('planning');
    case 'go-leads': return setView('leads');
    case 'go-gutscheine': return setView('gutscheine');
    case 'go-termine': return setView('termine');
    case 'go-plans-new': {
      s.plansOpenCreate = true;
      if (s.view === 'plans') { draw(); }
      else { setView('plans'); }
      return;
    }
    case 'go-projekte-new': { // projekte-new-opens-modal (React)
      s.projectsOpenCreate = true; // flag: ProjectsView oeffnet beim Mount das Erstell-Modal
      if (s.view === 'projekte') { draw(); } // schon auf der Seite: neu rendern, damit Mount das Flag liest
      else { setView('projekte'); }
      return;
    }
    case 'toggle-ws-menu': { s.wsMenuOpen = !s.wsMenuOpen; return draw(); }
    case 'open-firmenprofil': { s.wsMenuOpen = false; return setView('firmenprofil'); }
    case 'open-einstellungen': { s.wsMenuOpen = false; return setView('einstellungen'); }
    case 'set-section': {
      s.setSection = el.dataset.section;
      // Briefpapier: Live-Vorschau (Muster-Offerte mit echtem Briefpapier) nachladen
      if (s.setSection === 'briefpapier') { loadLetterheadPreview({ s, draw }); loadLetterheadBackgrounds({ s, draw }); }
      // Verbindungen: erst beim Öffnen laden — der Status kann sich jederzeit geändert
      // haben (Token abgelaufen, Handy entkoppelt), ein Wert aus load() wäre schon alt.
      if (s.setSection === 'verbindungen' && can('connections:read')) loadConnections({ s, draw }).then(draw);
      // Design zeigt das gespeicherte Logo — das steht im Firmenprofil und muss
      // mit Auth als Blob geholt werden (ein <img> auf die API-URL hätte keine).
      if (s.setSection === 'design') loadFirmenprofil();
      return draw();
    }
    case 'save-firmenprofil': return saveFirmenprofil();
    case 'set-theme': { // set-theme-handler
      // heisst bewusst nicht `t` — das ist die i18n-Funktion aus dem Import oben.
      const theme = el.getAttribute('data-theme');
      if (theme) { setOrgTheme(theme); draw(); }
      return;
    }
    case 'upload-logo': { const inp = document.getElementById('cd-logo-file'); if (inp) inp.click(); return; }
    // Papierkorb-Knopf im Sidebar-Fuss. Wie früher (openTrash): das Flag wird
    // immer gesetzt, sichtbar wird der Papierkorb nur in der Dokumente-Ansicht
    // — «Dokumente» in der Sidebar setzt es wieder zurück (go-documents).
    case 'go-trash':      docsUi.trashMode = true; if (s.view === 'documents') draw(); return;
    case 'confirm-yes':   return confirmYes();
    case 'confirm-no':    return closeConfirm();
    case 'close-send':    return closeSendModal();
    case 'submit-send':   return submitSendModal();
    case 'send-tab-email':    return setSendTab('email');
    case 'send-tab-whatsapp': return setSendTab('whatsapp');
    case 'send-wa-mode-chat':   return setSendWaMode('chat');
    case 'send-wa-mode-manual': return setSendWaMode('manual');
    case 'toggle-cc':     return toggleCcDropdown();
    case 'select-cc':     return selectCc(el.dataset.code);
    case 'toggle-sidebar': s.sidebarOpen = !s.sidebarOpen; draw(); return;
    case 'close-sidebar':  s.sidebarOpen = false; draw(); return;
    case 'logout':        logout().finally(() => location.reload()); return;
  }
  // customer card actions (cust-open, cust-close, ...) be CustomersView seporde mishavad
  if (a && a.startsWith('cust-')) {
    handleCustomerAction(a, el);
    return;
  }
}

// فقط آکاردئون را باز/بسته می‌کند — بدون بازسازیِ کل صفحه (تا KPIها رفرش نشوند)
function toggleAccordion() {
  s.accordionOpen = !s.accordionOpen;
  const container = root && root.querySelector('#cd-root');
  if (!container) return;
  const parent = container.querySelector('.cd-nav-parent');
  const wrap = container.querySelector('.cd-nav-subwrap');
  if (parent) parent.classList.toggle('open', s.accordionOpen);
  if (wrap) wrap.classList.toggle('open', s.accordionOpen);
}

// ── رندر ──
// Offene Editoren schreiben ihre DOM-Eingaben zurück in den State, BEVOR draw()
// das Markup ersetzt. Die drei Module hatten dieses syncFromDom längst, riefen es
// aber nur vor ihrem EIGENEN draw() auf — jeder andere Auslöser (Workspace-Menü
// öffnen, Sprache wechseln, Sidebar) hat getippte Werte verworfen.
// Jede der Funktionen prüft selbst, ob ihr Editor überhaupt offen ist.
function syncOpenEditors() {
  try {
    syncDunning(s);
    syncDocumentTexts(s);
    syncLetterhead(s);
  } catch {
    // ein kaputter Sync darf nie das Neuzeichnen verhindern
  }
}

function draw() {
  if (!root) return;
  const container = root.querySelector('#cd-root');
  if (!container) return;
  syncOpenEditors();

  const u = getUser() || {};
  const orgName = u?.organization?.name || t('dashboard.workspace');
  const wsInitials = initials(orgName, orgName);
  const userName = u?.name || u?.email || '';
  const roleName = u?.role?.name || '';

  const active = s.members.filter((m) => m.status === 'ACTIVE').length;

  // پیش از redraw: آیا فوکوس روی یکی از input های واتساپ است؟
  const focusedEl = document.activeElement;
  const focusedId =
    focusedEl && (focusedEl.id === 'cd-wa-search' || focusedEl.id === 'cd-wa-input' || focusedEl.id === 'cd-email-input' || focusedEl.id === 'cd-wachat-input') ? focusedEl.id : null;
  const caret = focusedId ? focusedEl.selectionStart : null;
  // cust2-tab-refocus-in-draw: aya focus rooye yek tab bud (ta ba'd az redraw bargardad)
  const cust2TabFocused = !!(focusedEl && focusedEl.classList && focusedEl.classList.contains('cd-cust2-tab'));

  // pish az redraw: hefz-e mooqeiyat-e scroll-e nahiye-ye payam-haye whatsapp
  // hefz-e scroll-e tab-pane (Übersicht) hangam-e redraw (mesl-e click-e download)
  const prevPane = container.querySelector('.cd-cust2-tab-pane');
  const cust2PaneScroll = prevPane ? prevPane.scrollTop : null;
  // hefz-e scroll-e list-e moshtari-ha (tbody) hangam-e redraw
  const prevList = container.querySelector('.cd-cust2-tbody');
  const cust2ListScroll = prevList ? prevList.scrollTop : null;

  const prevMsgScroll = container.querySelector('.cd-wa-msg-scroll');
  let waScrollTop = null;
  let waWasAtBottom = false;
  if (prevMsgScroll) {
    waScrollTop = prevMsgScroll.scrollTop;
    // agar ta paeen (akharin payam) bood, baad az render ham paeen bemanad
    waWasAtBottom = (prevMsgScroll.scrollHeight - prevMsgScroll.scrollTop - prevMsgScroll.clientHeight) < 80;
  }

  container.innerHTML = `
    <div class="cd-app">
      ${`<button class="cd-burger" data-action="toggle-sidebar" aria-label="${escapeHtml(t('dashboard.menu'))}">${icon('menu', 22)}</button>`}
      <div class="cd-mobile-title">${escapeHtml(viewTitle())}</div>
      <div class="cd-sidebar-overlay ${s.sidebarOpen ? 'cd-overlay-show' : ''}" data-action="close-sidebar"></div>
      ${sidebar(orgName, wsInitials, userName, roleName, u)}
      <main class="cd-main ${s.view === 'firmenprofil' ? 'cd-main-docform' : ''} ${s.view === 'documents' ? 'cd-main-doclist' : ''}">
        ${mainInner(active, userName)}
      </main>
    </div>`;
  s.firstDraw = false;

  // react-offer-mount: form-e React-e offerte ra dar div mount kon (migration)
  // react-picker-mount: CustomerPicker (React) mount kon
  if (s.view === 'documents' && s.reactCustomerPicker) {
    const el = container.querySelector('#react-picker-root');
    if (el) {
      // Das Offerten-Formular ist der NÄCHSTE Schritt — sein Bündel schon
      // laden, während der Nutzer den Kunden wählt. Sonst beginnt der Download
      // erst nach dem Klick und der Wechsel wirkt zäh (Voice: «Offerte
      // erstellen» → Formular). Fehlschlag egal: dann lädt es eben später.
      import('../../react/components/OfferForm.tsx').catch(() => {});
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/CustomerPicker.tsx'),
      ]).then(([{ mountReact }, { default: CustomerPicker }]) => {
        mountReact(el, CustomerPicker, {
          docType: s.reactCustomerPicker.docType,
          prefill: s.reactCustomerPicker.prefill || null, // Voice: diktierter Neukunde
          positions: s.reactCustomerPicker.positions || null, // Voice: genannte Arbeiten
          onBack: () => { s.reactCustomerPicker = null; draw(); },
          onPick: (customer) => {
            const dt = s.reactCustomerPicker.docType;
            s.reactCustomerPicker = null;
            s.reactOfferForm = { docType: dt, customer };
            draw();
          },
          // Voice-Weg: der Server hat bereits einen leeren Entwurf angelegt →
          // Formular im Bearbeiten-Modus öffnen (nur so hat das anschliessende
          // Positions-Diktat eine Dokument-ID, genau wie am Handy).
          onOpenDraft: (documentId) => {
            const dt = s.reactCustomerPicker ? s.reactCustomerPicker.docType : 'OFFER';
            s.reactCustomerPicker = null;
            s.reactOfferForm = { docType: dt, customer: null, editId: documentId };
            draw();
          },
        });
      });
    }
  }

  if (s.view === 'documents' && s.reactOfferForm) {
    const el = container.querySelector('#react-offer-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/OfferForm.tsx'),
      ]).then(([{ mountReact }, { default: OfferForm }]) => {
        const isEdit = !!s.reactOfferForm.editId;
        mountReact(el, OfferForm, {
          docType: s.reactOfferForm.docType,
          customer: s.reactOfferForm.customer,
          editId: s.reactOfferForm.editId || null,
          // im Edit-Modus fuehrt "Zurueck"/"Kunde aendern" nicht zum Picker (Kunde steht fest) → einfach zur Liste
          onBack: () => { if (isEdit) { s.reactOfferForm = null; draw(); return; } const dt = s.reactOfferForm.docType; s.reactOfferForm = null; s.reactCustomerPicker = { docType: dt }; draw(); }, // offerback-to-picker
          onCancel: () => { s.reactOfferForm = null; draw(); }, // offer-oncancel-wired: komplett abbrechen → Liste
          onChangeCustomer: () => { if (isEdit) return; const dt = s.reactOfferForm.docType; s.reactOfferForm = null; s.reactCustomerPicker = { docType: dt }; draw(); }, // change-cust-react-picker
          // nach dem Speichern direkt fragen, WOHIN senden (E-Mail/WhatsApp) —
          // Schliessen des Dialogs = nur speichern, nichts senden
          onSaved: (saved) => {
            s.reactOfferForm = null; docsUi.filter = 'today'; docsUi.trashMode = false; s.docsLoaded = false; draw(); loadDocuments();
            if (saved && saved.id) openSendModal(saved.id, saved.number);
          },
        });
      });
    }
  }

  // react-documents-mount: Dokumente-Liste (React-Insel). Direkt in <main>
  // mounten — die Scroll-CSS (.cd-main-doclist > .cd-topbar / > .cd-card)
  // arbeitet mit Direktkind-Selektoren; ein Wrapper-Div würde das Layout
  // (fixe Kopfzeile, intern scrollende Liste) brechen.
  if (s.view === 'documents' && !s.reactCustomerPicker && !s.reactOfferForm) {
    const el = container.querySelector('.cd-main');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/documents/DocumentsView.tsx'),
      ]).then(([{ mountReact }, { default: DocumentsView }]) => {
        mountReact(el, DocumentsView, {
          canAccountingWrite: can('accounting:write'),
          canDocumentsCreate: can('documents:create'),
          // Senden-Dialog bleibt (noch) Vanilla — das Insel-Dokument mitgeben,
          // damit der Dialog nicht auf den s.docs-Cache angewiesen ist.
          onSendDoc: (doc) => openSendModal(doc.id, doc.number, doc),
          // Bearbeiten oeffnet React-OfferForm im Edit-Modus (wie frueher edit-doc)
          onEditDoc: (doc) => { s.reactOfferForm = { docType: (doc && doc.type) || 'OFFER', customer: null, editId: doc.id }; draw(); },
          onNewOffer: () => { s.reactCustomerPicker = { docType: 'OFFER' }; draw(); }, // react-picker-open
          onNewInvoice: () => { s.reactCustomerPicker = { docType: 'INVOICE' }; draw(); },
          // nach jeder Mutation in der Insel: Shell-Kopie (s.docs) als veraltet markieren
          onDocsChanged: () => { s.docsLoaded = false; },
        });
      });
    }
  }

  // pd-stepper-lines-hook: agar safhe-ye jozviyat-e project baz ast, khotut-e monhani ra bekesh
  // react-projects-mount: ProjectsView (React) Liste mount kon
  if (s.view === 'projekte' && !s.reactProjectDetail) {
    const el = container.querySelector('#react-projects-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/ProjectsView.tsx'),
        apiListMembers().then((r) => (r && (r.members || r)) || []).catch(() => []),
      ]).then(([{ mountReact }, { default: ProjectsView }, members]) => {
        const openCreate = !!s.projectsOpenCreate;
        s.projectsOpenCreate = false; // flag konsumieren
        mountReact(el, ProjectsView, {
          onOpenProject: (id) => { s.reactProjectDetail = { projectId: id }; draw(); },
          members,
          openCreateOnMount: openCreate,
        });
      });
    }
  }

  if (s.view === 'plans') {
    const el = container.querySelector('#react-plans-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/PlansView.tsx'),
        apiListMembers().then((r) => (r && (r.members || r)) || []).catch(() => []),
        apiListProjects().then((r) => (r && (r.projects || r)) || []).catch(() => []),
      ]).then(([{ mountReact }, { default: PlansView }, members, projects]) => {
        const openCreate = !!s.plansOpenCreate;
        s.plansOpenCreate = false;
        mountReact(el, PlansView, {
          openCreateOnMount: openCreate,
          members,
          projects,
          onOpenProject: (id) => { s.reactProjectDetail = { projectId: id }; setView('projekte'); },
        });
      });
    }
  }

  // react-planning-mount: Planungstafel (React-Insel)
  if (s.view === 'planning') {
    const el = container.querySelector('#react-planning-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/planning/PlanningBoardView.tsx'),
      ]).then(([{ mountReact }, { default: PlanningBoardView }]) => {
        const focusDate = s.planningFocus || null;
        s.planningFocus = null; // Flag konsumieren, sonst springt die Tafel bei jedem Redraw zurück
        mountReact(el, PlanningBoardView, {
          // Termine verschieben/zuteilen ändert Projekte — dieselbe Berechtigung
          // wie PATCH /api/projects (Backend gated identisch).
          canWrite: can('customers:create'),
          onOpenProject: (id) => { s.reactProjectDetail = { projectId: id }; setView('projekte'); },
          focusDate,
        });
      });
    }
  }

  // react-calendar-mount: Termine/Firmenkalender (React-Insel)
  if (s.view === 'termine') {
    const el = container.querySelector('#react-calendar-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/CalendarView.tsx'),
      ]).then(([{ mountReact }, { default: CalendarView }]) => {
        // focusRequest: der Assistent hat einen Termin angelegt/geändert/gelöscht
      // → Kalender springt auf diesen Tag (gesetzt im OPEN_VIEW-Handler).
      mountReact(el, CalendarView, { canWrite: can('appointments:write'), focusRequest: s.termineFocus || null });
      });
    }
  }

  // react-leads-mount: Leads-Liste (React-Insel)
  if (s.view === 'leads') {
    const el = container.querySelector('#react-leads-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/LeadsView.tsx'),
      ]).then(([{ mountReact }, { default: LeadsView }]) => {
        const highlightId = s.leadsHighlightId || null;
        s.leadsHighlightId = null; // flag konsumieren (wie projectsOpenCreate)
        mountReact(el, LeadsView, {
          canWrite: can('leads:write'),
          canCreateOffer: can('documents:create'),
          highlightId,
          onOpenProject: (id) => { s.reactProjectDetail = { projectId: id }; setView('projekte'); },
          // Offerten-Entwurf im OfferForm-Edit-Modus öffnen (gleicher Pfad wie edit-doc)
          onOpenDocument: (id) => { setView('documents'); s.reactOfferForm = { docType: 'OFFER', customer: null, editId: id }; draw(); },
        });
      });
    }
  }

  // react-voucher-settings-mount: Einstellungen → Gutscheine (React-Insel)
  if (s.view === 'einstellungen' && s.setSection === 'gutscheine') {
    const el = container.querySelector('#react-voucher-settings-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/VoucherSettings.tsx'),
      ]).then(([{ mountReact }, { default: VoucherSettings }]) => {
        mountReact(el, VoucherSettings, { canWrite: can('vouchers:write') });
      });
    }
  }

  // react-vouchers-mount: Gutscheine (React-Insel)
  if (s.view === 'gutscheine') {
    const el = container.querySelector('#react-vouchers-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/VouchersView.tsx'),
      ]).then(([{ mountReact }, { default: VouchersView }]) => {
        mountReact(el, VouchersView, { canWrite: can('vouchers:write') });
      });
    }
  }

  // react-review-request-mount: Einstellungen → Bewertungs-Mail (React-Insel)
  if (s.view === 'einstellungen' && s.setSection === 'bewertung') {
    const el = container.querySelector('#react-review-request-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/ReviewRequestSettings.tsx'),
      ]).then(([{ mountReact }, { default: ReviewRequestSettings }]) => {
        mountReact(el, ReviewRequestSettings, { canWrite: can('layout:write') });
      });
    }
  }

  // react-agb-mount: Einstellungen → AGB & Co. (React-Insel)
  if (s.view === 'einstellungen' && s.setSection === 'agb') {
    const el = container.querySelector('#react-agb-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/AgbSettings.tsx'),
      ]).then(([{ mountReact }, { default: AgbSettings }]) => {
        mountReact(el, AgbSettings, { canWrite: can('layout:write') });
      });
    }
  }

  // react-doc-language-mount: Einstellungen → Dokumentsprache (React-Insel)
  if (s.view === 'einstellungen' && s.setSection === 'dokumentsprache') {
    const el = container.querySelector('#react-doc-language-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/DocumentLanguageSettings.tsx'),
      ]).then(([{ mountReact }, { default: DocumentLanguageSettings }]) => {
        mountReact(el, DocumentLanguageSettings, { canWrite: can('layout:write') });
      });
    }
  }

  // react-lead-agent-mount: Einstellungen → Lead-Agent (React-Insel)
  if (s.view === 'einstellungen' && s.setSection === 'lead-agent') {
    const el = container.querySelector('#react-lead-agent-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/LeadAgentSettings.tsx'),
      ]).then(([{ mountReact }, { default: LeadAgentSettings }]) => {
        mountReact(el, LeadAgentSettings, { canWrite: can('leads:write') });
      });
    }
  }

  // react-customers2-mount: Customers2View (React) Liste mount kon
  if (s.view === 'customers2') {
    const el = container.querySelector('#react-customers2-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/Customers2View.tsx'),
      ]).then(([{ mountReact }, { default: Customers2View }]) => {
        mountReact(el, Customers2View, {
          onNewCustomer: () => { requestAnimationFrame(function () { handleCustomerAction('cust-new', null); }); },
          onNachfassen: (docId, number) => openSendModal(docId, number), // send-modal (vanilla) bis eigener React-Umbau
        });
      });
    }
  }

  // react-project-mount: ProjectDetail (React) mount kon
  if (s.view === 'projekte' && s.reactProjectDetail) {
    const el = container.querySelector('#react-project-root');
    if (el) {
      Promise.all([
        import('../../react/lib/mountReact.tsx'),
        import('../../react/components/ProjectDetail.tsx'),
      ]).then(([{ mountReact }, { default: ProjectDetail }]) => {
        mountReact(el, ProjectDetail, {
          projectId: s.reactProjectDetail.projectId,
          onBack: () => { s.reactProjectDetail = null; draw(); },
          // partial-invoice-created: neue Abschlags-/Schlussrechnung sofort im
          // Bearbeiten-Modus öffnen (gleicher Pfad wie edit-doc).
          onOpenDocument: (id) => {
            s.reactProjectDetail = null;
            setView('documents');
            s.reactOfferForm = { docType: 'INVOICE', customer: null, editId: id };
            draw();
          },
        });
      });
    }
  }


  // پس از redraw: فوکوس input واتساپ را برگردان
  if (focusedId) {
    const el = container.querySelector('#' + focusedId);
    if (el) {
      el.focus();
      if (caret != null) { try { el.setSelectionRange(caret, caret); } catch { /* ignore */ } }
    }
  }
  // cust2-tab-refocus-in-draw: bazgardani-e focus be tab-e faal
  if (cust2TabFocused) {
    const activeTab = container.querySelector('.cd-cust2-tab.active');
    if (activeTab) activeTab.focus();
  }

  // pas az redraw: mooqeiyat-e scroll-e payam-ha
  // restore-e scroll-e tab-pane
  if (cust2PaneScroll != null) {
    const newPane = container.querySelector('.cd-cust2-tab-pane');
    if (newPane) newPane.scrollTop = cust2PaneScroll;
  }
  if (cust2ListScroll != null) {
    const newList = container.querySelector('.cd-cust2-tbody');
    if (newList) newList.scrollTop = cust2ListScroll;
  }

  const newMsgScroll = container.querySelector('.cd-wa-msg-scroll');
  if (newMsgScroll) {
    if (s.waScrollToBottom) {
      // chat tazeh baz shode -> boro ta akharin payam
      newMsgScroll.scrollTop = newMsgScroll.scrollHeight;
      s.waScrollToBottom = false;
    } else if (waWasAtBottom) {
      newMsgScroll.scrollTop = newMsgScroll.scrollHeight; // paeen bemanad
    } else if (waScrollTop != null) {
      newMsgScroll.scrollTop = waScrollTop; // haman ja ke bood
    }
  }

  // email-chat-scroll-bottom: tab-e Emails baz shod -> boro ta akharin payam (mesl-e chat)
  // email-scroll-raf: ba requestAnimationFrame ta ba'd az render-e vaghei-ye DOM ejra shavad (data async miayad)
  if (s.view === 'customers2' && (cust2ActiveTab === 'emails' || cust2ActiveTab === 'whatsapp')) { // wachat-scroll
    requestAnimationFrame(function () {
      const emailScroll = document.querySelector('.cd-inv-pane'); // scroll-target-pane-fix
      if (emailScroll) emailScroll.scrollTop = emailScroll.scrollHeight;
    });
  }

  // lightbox overlay — بعد از رندر اصلی، به container اضافه می‌شود
  if (s.waLightbox && s.waMediaCache[s.waLightbox]) {
    const lb = document.createElement('div');
    lb.className = 'cd-wa-lightbox';
    lb.innerHTML =
      '<button class="cd-wa-lightbox-close" data-action="close-lightbox">' + icon('close', 22) + '</button>' +
      '<div class="cd-wa-lightbox-backdrop" data-action="close-lightbox"></div>' +
      '<div class="cd-wa-lightbox-inner"><img src="' + s.waMediaCache[s.waLightbox] + '" class="cd-wa-lightbox-img" /></div>';
    container.appendChild(lb);
  }

  // Senden-Dialog + Confirm — ausgelagerte Overlay-Renderer (Dokument-Vorschau
  // und Nachweis-Dialog rendert jetzt die Dokumente-Insel selbst)
  renderSendModal(container);
  renderConfirmModal(container);

  // بارگیری blob های media در پس‌زمینه (بدون block کردن رندر)
  void hydrateWaMedia();
}

function sidebar(orgName, wsInitials, userName, roleName, u) {
  const open = s.accordionOpen;
  const sub = (action, ic, label, badge) => `
    <button class="cd-nav-sub" data-action="${action}">
      <span class="cd-nav-left">${icon(ic, 16)}${escapeHtml(label)}</span>
      ${badge != null && badge !== '' ? `<span class="cd-nav-badge">${badge}</span>` : ''}
    </button>`;

  let subItems = '';
  if (can('members:read')) subItems += sub('open-members', 'group', t('dashboard.nav.members'), s.members.length);
  if (can('roles:read'))   subItems += sub('open-roles', 'shield', t('dashboard.nav.roles'), s.roles.length);
  if (can('members:read')) subItems += sub('open-members', 'mail', t('dashboard.nav.invitations'), s.invitations.length || '');

  const accordion = subItems ? `
    <button class="cd-nav-item cd-nav-parent ${open ? 'open' : ''}" data-action="toggle-accordion">
      <span class="cd-nav-left">${icon('groups', 18)}${escapeHtml(t('dashboard.nav.usersGroup'))}</span>
      <span class="cd-nav-chevron">${icon('expand_more', 18)}</span>
    </button>
    <div class="cd-nav-subwrap ${open ? 'open' : ''}">${subItems}</div>` : '';

  return `
    <aside class="cd-sidebar ${s.sidebarOpen ? 'cd-sidebar-open' : ''}">
      <div class="cd-logo">
        <div class="cd-logo-icon">${icon('bolt', 20)}</div>
        <span class="cd-logo-name">LevelUp</span>
      </div>

      <div class="cd-ws ${s.wsMenuOpen ? 'open' : ''}">
        <button class="cd-workspace ${s.wsMenuOpen || s.view === 'firmenprofil' || s.view === 'einstellungen' ? 'active' : ''}" data-action="toggle-ws-menu" title="${escapeHtml(t('dashboard.nav.company'))}">
          <div class="cd-ws-badge">${escapeHtml(wsInitials)}</div>
          <div class="cd-ws-info">
            <div class="cd-ws-label">${escapeHtml(t('dashboard.workspaceLabel'))}</div>
            <div class="cd-ws-name">${escapeHtml(orgName)}</div>
          </div>
          <span class="cd-ws-gear ${s.wsMenuOpen ? 'flip' : ''}">${icon('expand_more', 18)}</span>
        </button>
        ${s.wsMenuOpen ? `
        <div class="cd-ws-menu">
          <button class="cd-ws-menu-item ${s.view === 'einstellungen' ? 'active' : ''}" data-voice-target="settings" data-action="open-einstellungen">
            <span class="cd-ws-menu-ic">${icon('build', 18)}</span>
            <span>${escapeHtml(t('dashboard.settings'))}</span>
          </button>
          <button class="cd-ws-menu-item ${s.view === 'firmenprofil' ? 'active' : ''}" data-action="open-firmenprofil">
            <span class="cd-ws-menu-ic">${icon('apartment', 18)}</span>
            <span>${escapeHtml(t('dashboard.companyDetails'))}</span>
          </button>
          ${langSwitcher()}
        </div>` : ''}
      </div>

      <nav class="cd-nav">
        <button class="cd-nav-item ${s.view === 'dashboard' ? 'active' : ''}" data-action="go-dashboard">
          <span class="cd-nav-left">${icon('dashboard', 18)}${escapeHtml(t('dashboard.nav.dashboard'))}</span>
        </button>
        ${viewAllowed('projekte') ? `
        <button class="cd-nav-item ${s.view === 'projekte' ? 'active' : ''}" data-action="go-projekte">
          <span class="cd-nav-left">${icon('folder', 18)}${escapeHtml(t('dashboard.nav.projects'))}</span>
          <span class="cd-nav-plus" data-action="go-projekte-new" title="${escapeHtml(t('dashboard.nav.newProject'))}">${icon('add', 16)}</span>
        </button>` : ''}<!-- projekte-moved-top -->
        ${viewAllowed('planning') ? `
        <button class="cd-nav-item ${s.view === 'planning' ? 'active' : ''}" data-action="go-planning" data-voice-target="planning">
          <span class="cd-nav-left">${icon('view_timeline', 18)}${escapeHtml(t('dashboard.nav.planning'))}</span>
        </button>` : ''}
        ${viewAllowed('plans') ? `
        <button class="cd-nav-item ${s.view === 'plans' ? 'active' : ''}" data-action="go-plans">
          <span class="cd-nav-left">${icon('timer', 18)}${escapeHtml(t('dashboard.nav.time'))}</span>
          <span class="cd-nav-plus" data-action="go-plans-new" title="${escapeHtml(t('dashboard.nav.newEntry'))}">${icon('add', 16)}</span>
        </button>` : ''}
        ${viewAllowed('termine') ? `
        <button class="cd-nav-item ${s.view === 'termine' ? 'active' : ''}" data-action="go-termine">
          <span class="cd-nav-left">${icon('calendar_month', 18)}${escapeHtml(t('dashboard.nav.appointments'))}</span>
        </button>` : ''}
        <div class="cd-nav-section">${escapeHtml(t('dashboard.nav.orgSection'))}</div>
        ${accordion}
        ${viewAllowed('leads') ? `
        <button class="cd-nav-item ${s.view === 'leads' ? 'active' : ''}" data-action="go-leads">
          <span class="cd-nav-left">${icon('person_search', 18)}${escapeHtml(t('dashboard.nav.leads'))}</span>
        </button>` : ''}
        ${viewAllowed('email') ? `
        <button class="cd-nav-item ${s.view === 'email' ? 'active' : ''}" data-action="go-email">
          <span class="cd-nav-left">${icon('mail', 18)}${escapeHtml(t('dashboard.nav.email'))}</span>
        </button>` : ''}
        ${viewAllowed('whatsapp') ? `
        <button class="cd-nav-item ${s.view === 'whatsapp' ? 'active' : ''}" data-action="go-whatsapp">
          <span class="cd-nav-left">${icon('chat', 18)}${escapeHtml(t('dashboard.nav.whatsapp'))}</span>
        </button>` : ''}
        ${viewAllowed('documents') ? `
        <button class="cd-nav-item ${s.view === 'documents' ? 'active' : ''}" data-action="go-documents">
          <span class="cd-nav-left">${icon('description', 18)}${escapeHtml(t('dashboard.nav.documents'))}</span>
        </button>` : ''}
        ${viewAllowed('gutscheine') ? `
        <button class="cd-nav-item ${s.view === 'gutscheine' ? 'active' : ''}" data-voice-target="vouchers" data-action="go-gutscheine">
          <span class="cd-nav-left">${icon('redeem', 18)}${escapeHtml(t('dashboard.nav.vouchers'))}</span>
        </button>` : ''}
        ${viewAllowed('customers2') ? `
        <button class="cd-nav-item ${s.view === 'customers2' ? 'active' : ''}" data-action="go-customers2">
          <span class="cd-nav-left">${icon('groups', 18)}${escapeHtml(t('dashboard.nav.contacts'))}</span>
          <span class="cd-nav-plus" data-action="go-customers2-new" title="${escapeHtml(t('dashboard.nav.newContact'))}">${icon('add', 16)}</span>
        </button>` : ''}<!-- nav-plus-buttons -->
      </nav>

      <div class="cd-sidebar-foot">
        <div class="cd-foot-row">
          <button class="cd-user-card" data-action="logout" title="${escapeHtml(t('dashboard.logout'))}">
            <div class="cd-user-ava" style="background:${grad(userName)};">${escapeHtml(initials(userName, u?.email))}</div>
            <div class="cd-user-info">
              <div class="cd-user-name">${escapeHtml(userName)}</div>
              <div class="cd-user-role">${escapeHtml(roleName || t('dashboard.member'))}</div>
            </div>
            ${icon('logout', 18)}
          </button>
          <button class="cd-foot-trash" data-action="go-trash" title="${escapeHtml(t('dashboard.nav.trash'))}" aria-label="${escapeHtml(t('dashboard.nav.trash'))}">${icon('delete', 18)}</button>
        </div>
      </div>
    </aside>`;
}

function topbar(userName) {
  const first = String(userName || '').split(/\s+/)[0] || '';
  const inviteBtn = can('members:invite')
    ? `<button class="cd-btn-primary" data-action="invite">${icon('person_add', 16)}${escapeHtml(t('dashboard.inviteMember'))}</button>`
    : '<span></span>';
  return `
    <header class="cd-topbar">
      <div class="cd-greeting">
        <h1>${escapeHtml(t('dashboard.welcome'))}${first ? ', ' + escapeHtml(first) : ''}</h1>
        <p>${escapeHtml(t('dashboard.subtitle'))}</p>
      </div>
      ${inviteBtn}
      <div class="cd-bell">${icon('notifications', 18)}${s.invitations.length ? `<span class="cd-bell-badge">${s.invitations.length}</span>` : ''}</div>
    </header>`;
}

// ================================================================
// View switching + Email page
// ================================================================
// onvan-e namayeshi-ye har view baraye header-e mobile
function viewTitle() {
  const map = {
    dashboard: t('dashboard.nav.dashboard'),
    email: t('dashboard.nav.email'),
    whatsapp: t('dashboard.nav.whatsapp'),
    documents: t('dashboard.nav.documents'),
    customers: t('dashboard.nav.contacts'),
    customers2: t('dashboard.nav.contacts'),
    projekte: t('dashboard.nav.projects'),
    plans: t('dashboard.nav.time'),
    planning: t('dashboard.nav.planning'),
    leads: t('dashboard.nav.leads'),
    termine: t('dashboard.nav.appointments'),
    firmenprofil: t('dashboard.companyDetails'),
    einstellungen: t('dashboard.settings'),
  };
  return map[s.view] || '';
}

function setView(v) {
  if (!viewAllowed(v)) v = 'dashboard'; // Modul-Gate: auch Deep-Links abfangen
  s.sidebarOpen = false; // mobile: ba taghir-e view sidebar baste shavad
  if (v === s.view) {
    if (v === 'dashboard') load();
    else if (v === 'email') loadEmails();
    else if (v === 'whatsapp') loadWaInstances();
    // Dokumente: draw() mountet die React-Insel neu — sie lädt ihre Liste
    // selbst nach; loadDocuments() hält daneben den Shell-Cache s.docs frisch.
    else if (v === 'documents') { draw(); loadDocuments(); }
    // Kalender schon offen + Assistent will einen Tag zeigen → neu zeichnen,
    // damit die React-Insel den frischen focusRequest bekommt.
    else if (v === 'termine' && s.termineFocus) draw();
    return;
  }
  // ترک نمای whatsapp → polling را متوقف کن
  if (s.view === 'whatsapp' && v !== 'whatsapp') { stopWaPoll(); stopWaChatsPoll(); }
  s.view = v;
  draw();
  if (v === 'email' && !s.emailLoaded) loadEmails();
  if (v === 'whatsapp') loadWaInstances();
  if (v === 'documents' && !s.docsLoaded) loadDocuments();
  if (v === 'customers2' && !s.cust2Loaded) loadCustomers2();
  if (v === 'customers2' && !s.docsLoaded) loadDocuments();
  if (v === 'firmenprofil') loadFirmenprofil();
}



var CUST2_STATUS = {
  DRAFT:    { label: 'Entwurf',            cls: 'gesendet' },
  SENT:     { label: 'Wartet auf Antwort', cls: 'warten' },
  ACCEPTED: { label: 'Akzeptiert',         cls: 'akzeptiert' },
  REJECTED: { label: 'Abgelehnt',          cls: 'abgelehnt' },
  UNPAID:   { label: 'Unbezahlt',          cls: 'unbezahlt' },
  PAID:     { label: 'Bezahlt',            cls: 'akzeptiert' },
};

























// vaz'iat-e namayeshi az roo-ye field-haye vaghei (DRAFT/FINAL + sent)

// sanad-e vaghei -> shekl-e row baraye render


var cust2PreviewLoadedFor = null;
var cust2PreviewSrc = null;

// TODO: 'test_anna_2' dade-ye testi ast — ba'dan bayad be moshtari-ye pooya vasl shavad
var CUST2_DEMO_CONTACT_ID = 'test_anna_2';
var cust2ActiveTab = 'invoices';
var cust2Verlauf = null;       // { customer, interactions }
var cust2VerlaufLoading = false;
var cust2VerlaufLoadedFor = null;
// kholase-ye AI (tab-e Übersicht)
var cust2Summary = null;
var cust2SummaryAt = null;
var cust2SummaryLoading = false;
var cust2SummaryLoadedFor = null;




// parse-e khploase-ye AI: talash baraye JSON {points, recommendations}, fallback be matn-e sade

let cust2PreviewRetry = 0;

function cs2NewForm() {
  return isNewFormOpen() ? newCustomerFormHtml() : '';
}



// faqat radif-haye tbody ra update mikonad (bedun-e draw -> search/scroll tekan nemikhorad)





function mainInner(active, userName) {
  if (s.view === 'email') return emailPage();
  if (s.view === 'whatsapp') return whatsappPage();
  if (s.view === 'documents') {
    if (s.reactCustomerPicker) return '<div id="react-picker-root" style="height:100%"></div>'; // react-picker-root-div
    if (s.reactOfferForm) return '<div id="react-offer-root" style="height:100%"></div>'; // react-offer-root-div
    // Dokumente-Liste: React-Insel, wird nach dem innerHTML direkt in <main>
    // gemountet (react-documents-mount in draw()) — hier bewusst leer.
    return '';
  }
  if (s.view === 'customers2') return '<div id="react-customers2-root" style="height:100%"></div>' + cs2NewForm() + (isTrashOpen() ? trashViewHtml() : ''); // react-customers2-root-div (Kontextmenu+Edit-Modal jetzt React)
  if (s.view === 'projekte') { // projects-view-wired + projekte-render-newform + project-detail-view-render
    if (s.reactProjectDetail) return '<div id="react-project-root" style="min-height:100vh"></div>'; // react-project-root-div
    return '<div id="react-projects-root" style="height:100%"></div>' + cs2NewForm(); // react-projects-root-div
  }
  if (s.view === 'plans') return '<div id="react-plans-root" style="height:100%"></div>';
  if (s.view === 'planning') return '<div id="react-planning-root" style="height:100%"></div>';
  if (s.view === 'leads') return '<div id="react-leads-root" style="height:100%"></div>';
  if (s.view === 'gutscheine') return '<div id="react-vouchers-root" style="height:100%"></div>';
  if (s.view === 'termine') return '<div id="react-calendar-root" style="height:100%"></div>';
  if (s.view === 'firmenprofil') return firmenprofilPage();
  if (s.view === 'einstellungen') return einstellungenPage();
  return `
        ${topbar(userName)}
        ${s.error ? `<div class="cd-error">${icon('error', 18)}<span>${escapeHtml(s.error)}</span></div>` : ''}
        ${can('email:read') ? emailKpis() : ''}
        <section class="cd-grid-tl">
          ${todayTimeline()}
        </section>
`;
}

// ================================================================
// Firmenprofil — تنظیمات اطلاعات شرکت (هدر سند + QR فاکتور)
// ================================================================
// Firmenprofil-Daten werden an ZWEI Stellen gezeigt: auf der Profil-Seite und
// (nur das Logo) in Einstellungen › Design. Beide müssen nachziehen, wenn das
// Laden fertig ist — sonst bleibt im Design-Bereich der leere Logo-Platzhalter
// stehen, obwohl längst ein Logo hinterlegt ist.
function drawsFirmenprofil() {
  return s.view === 'firmenprofil' || (s.view === 'einstellungen' && s.setSection === 'design');
}

async function loadFirmenprofil() {
  s.fpLoading = true; s.fpError = ''; s.fpSaved = false;
  if (drawsFirmenprofil()) draw();
  try {
    const r = await getCompanyProfile();
    const p = r.profile || {};
    s.fpForm = {
      legalName: p.legalName || '', logoUrl: p.logoUrl || '',
      street: p.street || '', postalCode: p.postalCode || '', city: p.city || '', country: p.country || 'CH',
      email: p.email || '', phone: p.phone || '', website: p.website || '',
      iban: p.iban || '', vatNumber: p.vatNumber || '',
      vatRatePercent: p.vatRatePercent != null ? p.vatRatePercent : 8.1,
    };
    // logo-ye zakhire-shode ra ba auth begir va preview kon (img-e sade auth nadarad)
    if (s.logoPreview && s.logoPreview.startsWith('blob:')) { try { URL.revokeObjectURL(s.logoPreview); } catch { /* ignore */ } }
    s.logoPreview = '';
    if (p.logoUrl) {
      fetchCompanyLogoBlob().then((url) => {
        if (url) { s.logoPreview = url; if (drawsFirmenprofil()) draw(); }
      }).catch(() => { /* logo nist */ });
    }
  } catch (e) {
    s.fpError = e.message || t('common.loadFailed');
  } finally {
    s.fpLoading = false;
    if (drawsFirmenprofil()) draw();
  }
}

function fpFieldInput(field, value) {
  if (!s.fpForm) return;
  s.fpForm[field] = value;
}

// ── upload-e logo: validate + send + update preview ──
async function handleLogoFile(file) {
  s.logoError = '';
  const okTypes = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
  if (!okTypes.includes(file.type)) {
    s.logoError = t('dashboard.firmenprofil.errFileType'); draw(); return;
  }
  if (file.size > 2 * 1024 * 1024) {
    s.logoError = t('dashboard.firmenprofil.errFileSize'); draw(); return;
  }
  s.logoUploading = true; draw();
  try {
    const r = await uploadCompanyLogo(file);
    if (s.fpForm && r && r.logoUrl) s.fpForm.logoUrl = r.logoUrl;
    // preview-e mahalli az khod-e file (bedoone niaz be auth/fetch)
    if (s.logoPreview && s.logoPreview.startsWith('blob:')) { try { URL.revokeObjectURL(s.logoPreview); } catch { /* ignore */ } }
    s.logoPreview = URL.createObjectURL(file);
    s.logoUploading = false;
    draw();
  } catch (e) {
    s.logoUploading = false;
    s.logoError = e.message || t('dashboard.firmenprofil.errUpload');
    draw();
  }
}

async function saveFirmenprofil() {
  if (!s.fpForm) return;
  s.fpSaving = true; s.fpError = ''; s.fpSaved = false; draw();
  try {
    const f = s.fpForm;
    await saveCompanyProfile({
      legalName: f.legalName, logoUrl: f.logoUrl,
      street: f.street, postalCode: f.postalCode, city: f.city, country: f.country || 'CH',
      email: f.email, phone: f.phone, website: f.website,
      iban: f.iban, vatNumber: f.vatNumber,
      vatRatePercent: f.vatRatePercent === '' ? null : Number(f.vatRatePercent),
    });
    s.fpSaved = true;
  } catch (e) {
    s.fpError = e.message || t('common.saveFailed');
  } finally {
    s.fpSaving = false; draw();
  }
}

// Settings-Navigation (plancraft-Stil, gruppiert). Nur Bereiche, die zu LevelUpWerk passen.
// Nur Struktur (Gruppe + Schlüssel + Icon). Die Beschriftungen kommen aus
// settings.nav.* — dieses Objekt entsteht beim Laden des Moduls und dürfte
// deshalb keine übersetzten Texte enthalten: sie wären für immer in der
// Sprache eingefroren, die beim Start aktiv war.
const SETTINGS_NAV = [
  { group: 'company', items: [
    { key: 'mitarbeiter', icon: 'group' },
    { key: 'unternehmensdetails', icon: 'apartment' },
    { key: 'arbeitszeiten', icon: 'schedule' },
    { key: 'feiertage', icon: 'event' },
    { key: 'rollen', icon: 'vpn_key' },
    { key: 'verbindungen', icon: 'hub' },
    // perm: nur zeigen, wenn die Rolle (und damit das gebuchte Modul — Entitlements
    // schneiden die Permissions schon im Backend) den Bereich überhaupt lesen darf.
    { key: 'lead-agent', icon: 'person_search', perm: 'leads:read' },
    { key: 'telefonassistent', icon: 'call' },
  ] },
  { group: 'layout', items: [
    { key: 'briefpapier', icon: 'description' },
    { key: 'texte', icon: 'article' },
    { key: 'dokumentsprache', icon: 'translate' },
    { key: 'anhaenge', icon: 'attach_file' },
    { key: 'dateinamen', icon: 'draft' },
    { key: 'email-versand', icon: 'mail' },
    { key: 'whatsapp-text', icon: 'chat' },
    { key: 'bewertung', icon: 'star' },
    { key: 'agb', icon: 'gavel' },
  ] },
  { group: 'accounting', items: [
    { key: 'nummernkreise', icon: 'tag' },
    { key: 'zahlungsziel', icon: 'payments' },
    { key: 'lohnkostenanteil', icon: 'engineering' },
    { key: 'bezahlcode', icon: 'qr_code_2' },
    { key: 'mahnungen', icon: 'receipt_long' },
    { key: 'abschlagsrechnungen', icon: 'request_quote' },
    { key: 'gutscheine', icon: 'redeem', perm: 'vouchers:read' },
  ] },
  { group: 'calculation', items: [
    { key: 'lohngruppen', icon: 'euro' },
    { key: 'bausteine', icon: 'widgets' },
    { key: 'zuschlaege', icon: 'percent' },
    { key: 'einheiten', icon: 'straighten' },
  ] },
  { group: 'appearance', items: [
    { key: 'design', icon: 'palette' },
  ] },
  // Eigene Gruppe: dieser Bereich gehört dem angemeldeten NUTZER, nicht der
  // Firma — und braucht darum auch kein `perm` (jeder darf sein Passwort ändern).
  { group: 'account', items: [
    { key: 'passwort', icon: 'password' },
  ] },
];

// Beschriftung eines Nav-Eintrags — bei jedem draw() frisch übersetzt.
const settingsNavLabel = (key) => t('settings.nav.' + key);

function settingsItemMeta(key) {
  for (const g of SETTINGS_NAV) {
    const it = g.items.find((i) => i.key === key);
    if (it) return { ...it, label: settingsNavLabel(key) };
  }
  return null;
}

function settingsContent() {
  const sec = s.setSection || 'mitarbeiter';
  const meta = settingsItemMeta(sec) || { label: t('settings.title'), icon: 'settings' };
  // `draw` gehört dazu, weil die MFA-Karte ihren Status beim ersten Rendern
  // nachlädt und danach EINMAL neu zeichnen muss (settingsAccount.js).
  const empCtx = { s, can, grad, initials, draw };
  let body;
  let headAction = '';
  if (sec === 'mitarbeiter') {
    headAction = inviteHeadButton(empCtx);
    body = renderEmployeesSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'arbeitszeiten') {
    headAction = workTimeHeadButton(empCtx);
    body = renderWorkTimeSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'lohngruppen') {
    headAction = wageGroupsHeadButton(empCtx);
    body = renderWageGroupsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'bausteine') {
    headAction = bausteineHeadButton(empCtx);
    body = renderBausteineSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'feiertage') {
    body = renderHolidaysSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'bewertung') {
    // React-Insel — wird nach dem draw() in #react-review-request-root gemountet.
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body"><div id="react-review-request-root"></div></div>`;
  }
  if (sec === 'gutscheine') {
    // React-Insel — wird nach dem draw() in #react-voucher-settings-root gemountet.
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body"><div id="react-voucher-settings-root"></div></div>`;
  }
  if (sec === 'agb') {
    // React-Insel — wird nach dem draw() in #react-agb-root gemountet.
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body"><div id="react-agb-root"></div></div>`;
  }
  if (sec === 'dokumentsprache') {
    // React-Insel — wird nach dem draw() in #react-doc-language-root gemountet.
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body"><div id="react-doc-language-root"></div></div>`;
  }
  if (sec === 'lead-agent') {
    // React-Insel — wird nach dem draw() in #react-lead-agent-root gemountet.
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body"><div id="react-lead-agent-root"></div></div>`;
  }
  if (sec === 'passwort') {
    headAction = accountHeadButton(empCtx);
    // Die Geräteliste kommt vom Server — anstossen, sobald der Bereich zum
    // ersten Mal gezeichnet wird. loadDevices zeichnet danach selbst neu.
    if (!s.dvDevices && !s.dvLoading) loadDevices(empCtx);
    body = renderAccountSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'verbindungen') {
    body = renderConnectionsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'rollen') {
    headAction = rolesHeadButton(empCtx);
    body = renderRolesSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'einheiten') {
    body = renderUnitsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'zuschlaege') {
    headAction = surchargesHeadButton(empCtx);
    body = renderSurchargesSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'texte') {
    headAction = documentTextsHeadButton(empCtx);
    body = renderDocumentTextsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'briefpapier') {
    body = renderLetterheadSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'bezahlcode') {
    body = renderPaymentCodeSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${paymentCodeHeadButton(empCtx)}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'mahnungen') {
    body = renderDunningSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${dunningHeadButton(empCtx)}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'lohnkostenanteil') {
    body = renderLabourCostDisplaySection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${labourCostDisplayHeadButton(empCtx)}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'abschlagsrechnungen') {
    body = renderPartialInvoiceSettingsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${partialInvoiceSettingsHeadButton(empCtx)}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'anhaenge') {
    body = renderAttachmentsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'whatsapp-text') {
    headAction = whatsappTextHeadButton(empCtx);
    body = renderWhatsappTextSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'email-versand') {
    headAction = emailSendHeadButton(empCtx);
    body = renderEmailSendSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'dateinamen') {
    body = renderFileNamingSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'nummernkreise') {
    headAction = numberRangesHeadButton(empCtx);
    body = renderNumberRangesSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'zahlungsziel') {
    headAction = paymentTermsHeadButton(empCtx);
    body = renderPaymentTermsSection(empCtx);
    return `
      <header class="cd-set-head">
        <h2>${escapeHtml(meta.label)}</h2>
        <div class="cd-set-head-actions">${headAction}
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </div>
      </header>
      <div class="cd-set-body">${body}</div>`;
  }
  if (sec === 'unternehmensdetails') {
    body = `
      <p class="cd-set-lead">${escapeHtml(t('dashboard.firmenprofil.settingsLead'))}</p>
      <button class="cd-btn-primary" data-action="open-firmenprofil">${icon('edit', 16)}${escapeHtml(t('dashboard.firmenprofil.editButton'))}</button>`;
  } else if (sec === 'design') {
    // Logo UND Farbe an EINEM Ort: beides ist der Auftritt der Firma. Das Logo
    // war bisher nur im Firmenprofil und in Briefpapier › Logo zu finden — wer
    // «wo ändere ich unser Logo?» dachte, suchte hier und fand nur Farben.
    // Dieselbe Steuerung wie im Firmenprofil (data-action=upload-logo +
    // #cd-logo-file), damit es EINEN Upload-Weg gibt und nicht zwei.
    const editable = can('org:settings');
    body = `
      <div class="cd-set-block">
        <h3 class="cd-set-block-title">${escapeHtml(t('settings.design.logoTitle'))}</h3>
        <p class="cd-set-lead">${escapeHtml(t('settings.design.logoLead'))}</p>
        <div class="cd-logo-row">
          ${s.logoPreview ? `<img class="cd-logo-preview" src="${s.logoPreview}" alt="${escapeHtml(t('dashboard.firmenprofil.logoOptional'))}">` : `<div class="cd-logo-empty">${icon('image', 22)}</div>`}
          <div class="cd-logo-actions">
            ${editable ? `<button type="button" class="cd-btn-ghost cd-btn-sm" data-action="upload-logo" ${s.logoUploading ? 'disabled' : ''}>${s.logoUploading ? '<span class="cd-mini-spin"></span>' + escapeHtml(t('dashboard.firmenprofil.uploading')) : icon('upload', 15) + escapeHtml(t('dashboard.firmenprofil.uploadLogo'))}</button>` : ''}
            <div class="cd-logo-hint">${escapeHtml(t('dashboard.firmenprofil.logoHint'))}</div>
            ${s.logoError ? `<div class="cd-logo-err">${escapeHtml(s.logoError)}</div>` : ''}
          </div>
          <input id="cd-logo-file" type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" style="display:none">
        </div>
      </div>
      <div class="cd-set-block">
        <h3 class="cd-set-block-title">${escapeHtml(t('settings.design.colorTitle'))}</h3>
        <p class="cd-set-lead">${escapeHtml(t('dashboard.firmenprofil.themeHint'))}</p>
        ${editable ? `<div class="cd-theme-row">${themeSwatchesHtml()}</div>` : `<div class="cd-logo-hint">${escapeHtml(t('settings.design.noPermission'))}</div>`}
      </div>`;
  } else {
    body = `<div class="cd-set-empty">${icon(meta.icon, 40)}<p>${escapeHtml(t('dashboard.comingSoon'))}</p></div>`;
  }
  return `
    <header class="cd-set-head">
      <h2>${escapeHtml(meta.label)}</h2>
      <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
    </header>
    <div class="cd-set-body">${body}</div>`;
}

function einstellungenPage() {
  const sec = s.setSection || 'mitarbeiter';
  const nav = SETTINGS_NAV.map((g) => `
    <div class="cd-set-group">${escapeHtml(t('settings.nav.groups.' + g.group))}</div>
    ${g.items.filter((it) => !it.perm || can(it.perm)).map((it) => `
      <button class="cd-set-item ${sec === it.key ? 'active' : ''}" data-action="set-section" data-section="${it.key}">
        <span class="cd-set-item-ic">${icon(it.icon, 18)}</span><span>${escapeHtml(settingsNavLabel(it.key))}</span>
      </button>`).join('')}`).join('');
  return `
    <div class="cd-settings-frame">
      <aside class="cd-set-nav">
        <div class="cd-set-nav-head">${escapeHtml(t('settings.title'))}</div>
        ${nav}
      </aside>
      <section class="cd-set-content">${settingsContent()}</section>
    </div>
    ${renderInviteModal({ s })}
    ${renderEditModal({ s })}
    ${renderWorkTimeModal({ s, can, grad, initials })}
    ${renderWageGroupModal({ s, can, grad, initials })}
    ${renderBausteinModal({ s, can })}
    ${renderHolidayModal({ s, can })}
    ${renderRoleModal({ s, can })}
    ${renderConnectionsModal({ s, can })}
    ${renderUnitsListModal({ s })}
    ${renderUnitDefaultsModal({ s })}
    ${renderFileNamingModal({ s })}
    ${renderLetterheadModal({ s })}
    ${renderDunningModal({ s })}
    ${renderDunningSendModal({ s })}`;
}

function firmenprofilPage() {
  if (s.fpLoading || !s.fpForm) {
    return `
      <div class="cd-docform-frame">
        <header class="cd-docform-head">
          <div class="cd-greeting"><h1>${escapeHtml(t('dashboard.companyDetails'))}</h1><p>${escapeHtml(t('dashboard.firmenprofil.subtitleShort'))}</p></div>
          <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
        </header>
        <div class="cd-docform-body"><div class="cd-muted">${escapeHtml(t('dashboard.loading'))}</div></div>
      </div>`;
  }
  const f = s.fpForm;
  return `
    <div class="cd-docform-frame">
      <header class="cd-docform-head">
        <div class="cd-greeting"><h1>${escapeHtml(t('dashboard.companyDetails'))}</h1><p>${escapeHtml(t('dashboard.firmenprofil.subtitle'))}</p></div>
        <button class="cd-btn-ghost" data-action="go-dashboard">${icon('arrow_back', 15)}${escapeHtml(t('dashboard.back'))}</button>
      </header>
      <div class="cd-docform-body">
        ${s.fpError ? `<div class="cd-error">${icon('error', 18)}<span>${escapeHtml(s.fpError)}</span></div>` : ''}
        ${s.fpSaved ? `<div class="cd-ok">${icon('check', 18)}<span>${escapeHtml(t('dashboard.firmenprofil.saved'))} ✓</span></div>` : ''}

        <div class="cd-form-section">${escapeHtml(t('dashboard.firmenprofil.sectionCompany'))}</div>
        <div class="cd-form-grid">
          <label class="cd-field cd-col2"><span>${escapeHtml(t('dashboard.firmenprofil.legalName'))} *</span><input class="cd-input" data-fp-field="legalName" placeholder="Muster GmbH" value="${escapeHtml(f.legalName)}"></label>
          <div class="cd-field cd-col2">
            <span>${escapeHtml(t('dashboard.firmenprofil.logoOptional'))}</span>
            <div class="cd-logo-row">
              ${s.logoPreview ? `<img class="cd-logo-preview" src="${s.logoPreview}" alt="Logo">` : `<div class="cd-logo-empty">${icon('image', 22)}</div>`}
              <div class="cd-logo-actions">
                <button type="button" class="cd-btn-ghost cd-btn-sm" data-action="upload-logo" ${s.logoUploading ? 'disabled' : ''}>${s.logoUploading ? '<span class="cd-mini-spin"></span>' + escapeHtml(t('dashboard.firmenprofil.uploading')) : icon('upload', 15) + escapeHtml(t('dashboard.firmenprofil.uploadLogo'))}</button>
                <div class="cd-logo-hint">${escapeHtml(t('dashboard.firmenprofil.logoHint'))}</div>
                ${s.logoError ? `<div class="cd-logo-err">${escapeHtml(s.logoError)}</div>` : ''}
              </div>
              <input id="cd-logo-file" type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" style="display:none">
            </div>
          </div>
        </div>

        <div class="cd-form-section">${escapeHtml(t('dashboard.firmenprofil.sectionAddress'))}</div>
        <div class="cd-form-grid">
          <label class="cd-field cd-col2"><span>${escapeHtml(t('dashboard.firmenprofil.street'))} *</span><input class="cd-input" data-fp-field="street" placeholder="Musterstrasse 1" value="${escapeHtml(f.street)}"></label>
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.postalCode'))} *</span><input class="cd-input" data-fp-field="postalCode" placeholder="3000" value="${escapeHtml(f.postalCode)}"></label>
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.city'))} *</span><input class="cd-input" data-fp-field="city" placeholder="Bern" value="${escapeHtml(f.city)}"></label>
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.country'))}</span><input class="cd-input" data-fp-field="country" value="${escapeHtml(f.country)}"></label>
        </div>

        <div class="cd-form-section">${escapeHtml(t('dashboard.firmenprofil.sectionContact'))}</div>
        <div class="cd-form-grid">
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.email'))}</span><input class="cd-input" data-fp-field="email" type="email" value="${escapeHtml(f.email)}"></label>
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.phone'))}</span><input class="cd-input" data-fp-field="phone" value="${escapeHtml(f.phone)}"></label>
          <label class="cd-field cd-col2"><span>${escapeHtml(t('dashboard.firmenprofil.website'))}</span><input class="cd-input" data-fp-field="website" value="${escapeHtml(f.website)}"></label>
        </div>

        <div class="cd-form-section">${escapeHtml(t('dashboard.firmenprofil.sectionPayment'))}</div>
        <div class="cd-form-grid">
          <label class="cd-field cd-col2"><span>${escapeHtml(t('dashboard.firmenprofil.iban'))} *</span><input class="cd-input" data-fp-field="iban" placeholder="CH93 0076 2011 6238 5295 7" value="${escapeHtml(f.iban)}"></label>
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.vatNumber'))}</span><input class="cd-input" data-fp-field="vatNumber" placeholder="CHE-123.456.789 MWST" value="${escapeHtml(f.vatNumber)}"></label>
          <label class="cd-field"><span>${escapeHtml(t('dashboard.firmenprofil.vatRate'))}</span><input class="cd-input" data-fp-field="vatRatePercent" type="number" min="0" max="100" step="0.1" value="${escapeHtml(String(f.vatRatePercent))}"></label>
        </div>
        ${can('org:settings') ? `
        <div class="cd-form-section">${escapeHtml(t('dashboard.firmenprofil.sectionDesign'))}</div>
        <div class="cd-theme-row">
          ${themeSwatchesHtml()}
        </div>
        <p class="cd-form-hint">${escapeHtml(t('dashboard.firmenprofil.themeHint'))}</p>
        ` : ''}
        <p class="cd-form-hint">${escapeHtml(t('dashboard.firmenprofil.requiredHint'))}</p>
      </div>
      <footer class="cd-docform-foot">
        <button class="cd-btn-primary" data-action="save-firmenprofil" ${s.fpSaving ? 'disabled' : ''}>${icon('check', 16)}${escapeHtml(s.fpSaving ? t('common.saving') : t('common.save'))}</button>
      </footer>
    </div>`;
}

